import localStorageUtils from "@iso/lib/helpers/localStorageUtils";

const getValue = (state, keyPath) => state.infiAuth.getIn(keyPath);

const getToken = state => {
  const stateToken = getValue(state, ["accessToken"]);
  const localStorageToken = localStorageUtils.getToken();
  // TODO: Sync state token and the local storage token
  return stateToken || localStorageToken;
};

const getLoading = state => getValue(state, ["loading"]);
const getError = state => getValue(state, ["error"]);

const InfiAuthSelectors = {
  getToken,
  getLoading,
  getError
};

export default InfiAuthSelectors;
